import React, { useState, useEffect } from 'react';
import CustomPagination from '../../common/Pagination';
import Axios from '../../../services/AxiosInstance';
import Notification from "../../Notification";
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Row, Col, Container, Table } from "react-bootstrap";
import { makeStyles } from '@mui/styles';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
const useStyles = makeStyles((theme) => ({
  backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#348cd4',
  },
}));
const BuyPlanRequest = () => {
  const classes = useStyles();
  const Navigate = useNavigate();
  const [loader, setLoader] = useState({ isOpen: false, isData: '' });
  const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' });
  const [totalPages, setTotalPage] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE);
  const [requestList, setRequestList] = useState([]);

  const getBuyContactsRequests = async () => {
    Axios.get(`api/admin/get-request-buy-plan?pageNo=${pageNum}&perPage=${perPage}`)
      .then((res) => {
        console.log(res);
        setRequestList(res.data.data.data);
        setTotalPage(res.data.data.totalPage);
      })
      .catch((error) => {
        console.log(error);
      })
  }

  useEffect(() => {
    getBuyContactsRequests();
  }, [pageNum, perPage])


  const showRequestlist = requestList.map((item, index) => {
    console.log("item",item.new_group,"selected_group",item.selected_group);
    return (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.user_name}</td>
        <td>{item.business_name}</td>
        <td>{item.mobile_no}</td>
        <td>{item.country_name}</td>
        <td>{item.state_name}</td>
        <td>{item.district_name}</td>
        <td>{item.gender}</td>
        {item?.selected_group !== undefined?<td>{item.selected_group.group_name}</td>:<td>N/A</td>}
        {item?.new_group !== undefined  ?<td>{item.new_group}</td>:<td>N/A</td>}
        <td>{item.package_name}</td>
        <td>{item.subscription_type}</td>
        <td>{item.price}</td>
        <td>{new Date(item.added_date).toDateString()}</td>
        <td>{item.status}</td>
        <td>{item.status === 'Pending' ? <button onClick={() => handleActivate(index)}>Activate</button> : 'Activated'}</td>
      </tr>
    )
  })

  const handleActivate = (index) => {
    Navigate(`/insert-plans-payment?business_id=${requestList[index].business_id}&business_name=${requestList[index].business_name}&plan_request_id=${requestList[index].plan_request_id}`)

    // Axios.post(`api/admin/activate-buy-plan?plan_request_id=${plan_request_id}`, setLoader({ isOpen: true }))
    //   .then((res) => {
    //     console.log(res.data);
    //     getBuyContactsRequests();
    //     setLoader({ isOpen: false });
    //     setNotify({
    //       isOpen: true,
    //       messsage: `${res.data.message}`,
    //       type: 'success',
    //     })
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setLoader({ isOpen: false });
    //     setNotify({
    //       isOpen: true,
    //       messsage: `${err.response.data.message}`,
    //       type: 'error'
    //     })
    //   })
  }

  return (
    <>
      <div className="content-page">
        <div className="content">

          <div className="container-fluid">

            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title">Request For Buy Plan</h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="tble-row table-responsive">
                  <table id="datatable" className="table table-bordered business_tb  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>User Name</th>
                        <th>Business Name</th>
                        <th>Mobile Number</th>
                        <th>Country Name</th>
                        <th>State Name</th>
                        <th>District Name</th>
                        <th>Gender</th>
                        <th>Select Group</th>
                        <th>New Group</th>
                        <th>Package Name</th>
                        <th>Subscription Type</th>
                        <th>Price</th>
                        <th>Added Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {showRequestlist}
                    </tbody>
                  </table>

                  <CustomPagination pageNum={pageNum} setPageNum={setPageNum} totalPage={totalPages} />
        
                  <div className="slect-pg-row">
                    <span><b>Rows per page :- </b></span>
                    <select name="Rows per page"
                      className="item-page"
                      onChange={(e) => setPerpage(e.target.value)}
                    >
                      <option value="">Select Item Per Page</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                    </select>
                  </div>

                </div>
              </div>
            </div>
            {/* <!-- end row --> */}
          </div>
  

        </div>
        {
          notify.isOpen ?
            <Notification
              notify={notify}
              setNotify={setNotify} />
            : ""
        }

        {loader.isOpen ?
          <Backdrop className={classes.backdrop} open>
            <CircularProgress color="inherit" />
          </Backdrop>
          : ""}
      </div>

      {/* <!-- end content --> */}

    </>
  )
}

export default BuyPlanRequest